var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLaunchpad = function SvgLaunchpad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.281,
    y: 15.043,
    width: 7.676,
    height: 7.676,
    rx: 1.362,
    stroke: "url(#launchpad_svg__a)",
    strokeWidth: 2.229
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.043,
    y: 15.043,
    width: 7.676,
    height: 7.676,
    rx: 1.362,
    stroke: "url(#launchpad_svg__b)",
    strokeWidth: 2.229
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.281,
    y: 3.281,
    width: 7.676,
    height: 7.676,
    rx: 1.362,
    stroke: "url(#launchpad_svg__c)",
    strokeWidth: 2.229
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.043,
    y: 3.281,
    width: 7.676,
    height: 7.676,
    rx: 1.362,
    stroke: "url(#launchpad_svg__d)",
    strokeWidth: 2.229
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "launchpad_svg__a",
    x1: 2.167,
    y1: 13.929,
    x2: 12.071,
    y2: 24.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BB8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "launchpad_svg__b",
    x1: 13.929,
    y1: 13.929,
    x2: 24.453,
    y2: 24.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "launchpad_svg__c",
    x1: 2.167,
    y1: 2.167,
    x2: 12.071,
    y2: 12.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ABB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CD6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "launchpad_svg__d",
    x1: 13.929,
    y1: 2.167,
    x2: 24.453,
    y2: 12.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F33DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C145ED"
  })))));
};
export default SvgLaunchpad;